import { useEffect, useState } from 'react'

/** Tailwind grid for audience cards on desktop; keep in sync with collapse row sizing. */
export const AUDIENCE_CARD_GRID_CLASS =
  'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5'

/**
 * Column count for the first "row" of the audience card grid at the current viewport.
 * Matches `AUDIENCE_CARD_GRID_CLASS` breakpoints.
 */
export function useAudienceGridColumns(): number {
  const [columnsPerRow, setColumnsPerRow] = useState(3)

  useEffect(() => {
    function updateColumns() {
      if (window.matchMedia('(min-width: 1280px)').matches) {
        setColumnsPerRow(3)
      } else if (window.matchMedia('(min-width: 768px)').matches) {
        setColumnsPerRow(2)
      } else {
        setColumnsPerRow(1)
      }
    }
    updateColumns()
    window.addEventListener('resize', updateColumns)
    return () => window.removeEventListener('resize', updateColumns)
  }, [])

  return columnsPerRow
}
